const restaurant = {
  restaurant: "Restoran", // translated 
  restaurants: "Restoran", // translated 
  category: "Kategori", // translated 
  score: "Skor", // translated 
  priceQuartile: "Kuartil harga", // translated 
  scoreLowestFirst: "Skor (terendah dulu)", // translated 
  scoreHighestFirst: "Skor (yang tertinggi terlebih dahulu)", // translated 
  priceLowestFirst: "Harga (terendah dulu)", // translated 
  priceHighestFirst: "Harga (yang tertinggi terlebih dahulu)", // translated 
  allPrices: "Semua harga", // translated 
  reserve: "Menyimpan", // translated 
  dining: "Makan", // translated 
};


export default restaurant;
